<template>
  <div class="c-convincing-deactivating-list">
    <h6 class="title is-spaced">
      Sabia que o Casar.com possui a melhor taxa do mercado?
    </h6>
    <p class="subtitle is-medium">E o melhor, sem asteriscos ou surpresas!</p>

    <ul class="benefits-list">
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        <span>
          Taxa única de
          <span class="has-text-primary">3,89%</span> independente do valor
          arrecadado;
        </span>
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        <span>
          Menor tempo de repasse do mercado;
        </span>
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        <span>
          Transferências
          <span class="has-text-primary">gratuitas e ilimitadas</span> para sua
          conta bancária;
        </span>
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        E você ainda pode repassar a taxa para os convidados, assim ela ficará
        embutida no valor do presente e não será descontada do casal ;)
      </li>
    </ul>

    <a
      @click="$emit('keepList')"
      href="https://ajuda.casar.com/support/tickets/new"
      target="_blank"
      class="button is-primary"
    >
      Quero tirar todas as minhas dúvidas sobre taxas
    </a>
    <p>
      <a @click="$emit('disableList')" class="link" href="#">
        Quero desativar a minha lista de presentes
      </a>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  methods: {},
}
</script>
